import React, { useState } from 'react';
import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonContent, IonHeader, IonIcon, IonImg, IonItem, IonLabel, IonList, IonListHeader, IonModal, IonTitle, IonToolbar, IonicSlides } from '@ionic/react';

import location from '../assets/location-pin-dark.svg'
import './CardArq.css'
import { SitiosArqProps } from '../../src/interfaces';
import { alarmSharp, arrowBack, callSharp, linkSharp, medalSharp } from 'ionicons/icons';
import { 
  cash, earth, medal, time, calendar, business, sparkles, flag, compass, 
  image, map, images, accessibility, construct, bulb, ribbon 
} from 'ionicons/icons';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/controller'
import { Autoplay, Keyboard, Pagination, Scrollbar, Zoom } from 'swiper';
import closePage from '../assets/close-circle.svg'

import 'swiper/css';
import 'swiper/css/autoplay';
import 'swiper/css/keyboard';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import 'swiper/css/zoom';
import '@ionic/react/css/ionic-swiper.css';
import { useTranslation } from "react-i18next";


function CardArq({nombre, traduccion, municipio, latitud, longitud, descripcion, horario, sitio_web, precio, tipo, promocion, urlImagen,
  duracion_visita, cronologia, func_original, mitos, eventos_historicos, descubrimiento, estructuras_iconicas, rutas_sugeridas, colecciones_destacadas,
  accesibilidad, instalaciones, recomendaciones, reconocimientos} : SitiosArqProps) {
  const [isOpen1, setIsOpen1] = useState(false);

  const [t, i18n] = useTranslation("global");
  
  return (
    <>
      <IonCard id='cardArt' color="light" onClick={() => setIsOpen1(true)} /*routerLink='/Menu'*/ >
        <img className="CardRes" alt={nombre} src={urlImagen[0]} onError={(e) => {
  e.currentTarget.onerror = null; 
  e.currentTarget.src = 'https://mexicoprofundo.app/fallback-imgs/collage-fallback.png';
}}
/>
        <IonCardHeader>
          <IonCardTitle>{nombre}</IonCardTitle>
        </IonCardHeader>

        <IonCardContent>
            <div className="localidad-card">
                        <div className="icon-loc">
                            <IonImg
                                src={location}            
                                alt="Location"
                            ></IonImg>
                        </div>
                        <div className="lugar">
                            {municipio}
                        </div>
            </div>
            <div className="score">
              ${precio}.00 MXN
            </div>
        </IonCardContent>
      </IonCard>

      <IonModal isOpen={isOpen1} keepContentsMounted={true}>
        <IonHeader className='art-ion-header'>
          <IonToolbar className='name-header-modal1 toolbar-modal-arq'>
              <IonButtons className='button-close'>
                <IonButton className='text-close-arq' onClick={() => setIsOpen1(false)}>
                  <img src={closePage} alt="imageClose" id='icon-close' />
                </IonButton>
              </IonButtons>
              <div className="image-potada">
                <img className='header-modal-img-arq'
                  src={urlImagen[0]}
                  alt={nombre}
                  onError={(e) => {
  e.currentTarget.onerror = null; 
  e.currentTarget.src = 'https://mexicoprofundo.app/fallback-imgs/collage-fallback.png';
}}

                />

              </div>
            <IonTitle>
            <div className="title">
                    <div className="localidad">
                        <div className="icon-loc">
                            <IonImg
                                src={location}            
                                alt="Location"
                            ></IonImg>
                        </div>
                        <div className="lugar">
                            {nombre}
                        </div>
                    </div>
                    <div className="precio">
                        <div className="cantidad">
                            ${precio}.00
                        </div>
                        <div className="moneda">
                            Mxn
                        </div>
                    </div>
                </div>
            </IonTitle>
          </IonToolbar>
        </IonHeader>
        
        <IonContent fullscreen={true} className="ion-padding">
        <div className="content-arq paddingt_7">
            <div className="title-name paddingt_7">
                <h1>{nombre}: {municipio}</h1>
            </div>
            <div className="description">
                <p>{traduccion}</p>
            </div>
        </div>
        <p>
            {descripcion}
        </p>

                <Swiper
                        // spaceBetween={5}
                        modules={[Autoplay, Keyboard, Pagination, Scrollbar, Zoom, IonicSlides]}
                        autoplay={true}
                        keyboard={true}
                        pagination={{
                          dynamicBullets: true,
                        }}
                        scrollbar={true}
                        zoom={true}
                        slidesPerView={1}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                      >
                      {urlImagen.map((element, index) => 
                    <>
                      <SwiperSlide>
                        <IonCard id='swiper-ioncard'>
                        <img className="img-swiper" alt='{nombre}' src={element} />
                          <IonCardHeader>
                            <IonCardTitle>{nombre}</IonCardTitle>
                          </IonCardHeader>
                        </IonCard>
                      </SwiperSlide>
                        </>
                      )
                      }
                </Swiper>
        

        <IonList className='Incluye'>
            <h3>{t("arqueologia.detalles")}</h3>
            <IonItem>
              <IonIcon icon={alarmSharp} slot="start"></IonIcon>
              <IonLabel>{t("arqueologia.horario")}: {horario}</IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={linkSharp} slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{sitio_web}</IonLabel>
            </IonItem>

            <IonItem>
              <IonIcon icon={medalSharp} slot="start"></IonIcon>
              <IonLabel className="ion-text-wrap">{t("arqueologia.promocion")}: {promocion}</IonLabel>
            </IonItem>

            {/* Precio */}
            <IonItem>
                <IonIcon icon={cash} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.precio")}: {precio}</IonLabel>
            </IonItem>

            {/* Tipo */}
            <IonItem>
                <IonIcon icon={earth} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.tipo")}: {tipo}</IonLabel>
            </IonItem>

            {/* Duración visita */}
            <IonItem>
                <IonIcon icon={time} slot="start"></IonIcon>
                <IonLabel>{t("arqueologia.duracion_visita")}: {duracion_visita}</IonLabel>
            </IonItem>

            {/* Cronología */}
            <IonItem>
                <IonIcon icon={calendar} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.cronologia")}: {cronologia}</IonLabel>
            </IonItem>

            {/* Función original */}
            <IonItem>
                <IonIcon icon={business} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.func_original")}: {func_original}</IonLabel>
            </IonItem>

            {/* Mitos */}
            <IonItem>
                <IonIcon icon={sparkles} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.mitos")}: {mitos}</IonLabel>
            </IonItem>

            {/* Eventos históricos */}
            <IonItem>
                <IonIcon icon={flag} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.eventos_historicos")}: {eventos_historicos}</IonLabel>
            </IonItem>

            {/* Descubrimiento */}
            <IonItem>
                <IonIcon icon={compass} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.descubrimiento")}: {descubrimiento}</IonLabel>
            </IonItem>

            {/* Estructuras icónicas */}
            <IonItem>
                <IonIcon icon={image} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.estructuras_iconicas")}: {estructuras_iconicas}</IonLabel>
            </IonItem>

            {/* Rutas sugeridas */}
            <IonItem>
                <IonIcon icon={map} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.rutas_sugeridas")}: {rutas_sugeridas}</IonLabel>
            </IonItem>

            {/* Colecciones destacadas */}
            <IonItem>
                <IonIcon icon={images} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.colecciones_destacadas")}: {colecciones_destacadas}</IonLabel>
            </IonItem>

            {/* Accesibilidad */}
            <IonItem>
                <IonIcon icon={accessibility} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.accesibilidad")}: {accesibilidad}</IonLabel>
            </IonItem>

            {/* Instalaciones */}
            <IonItem>
                <IonIcon icon={construct} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.instalaciones")}: {instalaciones}</IonLabel>
            </IonItem>

            {/* Recomendaciones */}
            <IonItem>
                <IonIcon icon={bulb} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.recomendaciones")}: {recomendaciones}</IonLabel>
            </IonItem>

            {/* Reconocimientos */}
            <IonItem>
                <IonIcon icon={ribbon} slot="start"></IonIcon>
                <IonLabel className="ion-text-wrap">{t("arqueologia.reconocimientos")}: {reconocimientos}</IonLabel>
            </IonItem>
        </IonList>


        </IonContent>
      </IonModal>
    
    
    </>

  );
}


export default CardArq;
